import { useState } from "react";
import styles from "./login.module.css";
import logo from "../../images/logo.png";
import bg from "../../images/login_therapists_bg.png";
import LoginSmsForm from "../../components/forms/loginSmsForm/loginSmsForm";
import LoginEmailForm from "../../components/forms/loginEmailForm/loginEmailForm";
import { tWithKeyAttr as t } from "../../i18nHelper";
import i18n from "../../i18n";



interface LPageProps {
  setData: (data:boolean) => void; 
}
function LoginPage({ setData }:LPageProps) {
  const [way, setWay] = useState("email");


  return (
    <section className={`${styles.loginAdminPage}`} data-testid="login-page" dir={i18n.dir()}>
      <img
        src={logo}
        alt={t('LOGO')}
        className={`${styles.loginTherapistPageLogo} ${styles.loginTherapistPageLogo_mobile}`}
      />
      <div className={styles.loginTherapistContent}>
        <img
          src={logo}
          alt={t('LOGO')}
          className={styles.loginTherapistPageLogo}
        />
        <h2 className={styles.loginTherapistTitle}>{t("ADMIN_AREA")}</h2>
        <img
          src={bg}
          className={styles.loginTherapistImage}
          alt={t('TWO_HAPPY_WOMEN_SEATED')}
        />
      </div>
      <article className={`${styles.login}`}>
        <h1 className={styles.login__title}>{t('PERSONAL_AREA_ACCESS')}</h1>
        <p className={styles.login__text}>{t('LOGIN_TO_YOUR_ACCOUNT')}</p>
        <div className={styles.login__way}>
          <button
            type="button"
            onClick={() => setWay("email")}
            className={`${styles.login__radioLabel} ${
              way === "email" && styles.login__radioLabel_active
            }`}
            data-testid="email-tab-button"
          >{t('EMAIL')}</button>
          <button
            type="button"
            onClick={() => setWay("sms")}
            className={`${styles.login__radioLabel} ${
              way === "sms" && styles.login__radioLabel_active
            }`}
            data-testid="sms-tab-button"
          >
            SMS
          </button>
        </div>
        {way === "sms" ? <LoginSmsForm /> : <LoginEmailForm />}
      </article>
    </section>
  );
}

export default LoginPage;
